/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AuthService } from "../services";
import { Spinner as SpinnerComponent } from "../components";

export const TOKEN_KEY = "borralo_token";
export const USER_KEY = "borralo_user";

export const AuthContext = createContext({
  user: null,
  conversion: 0,
  currentRouter: null,
  isLogged: false,
  isLoading: true,
  login: () => {},
  logout: () => {},
  setConversion: () => {},
});

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  // Carga inicial sincrónica desde localStorage
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem(USER_KEY);
      return savedUser ? JSON.parse(savedUser) : null;
    } catch {
      return null;
    }
  });

  const [conversion, setConversion] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const token = localStorage.getItem(TOKEN_KEY);
  const isLogged = !!token || !!user;

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setUser(null);
    AuthService.logout();
    dispatch({ type: "SET_USER", payload: null });
    dispatch({ type: "SET_JWT", payload: null });
  };

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
  };

  useEffect(() => {
    if (token) {
      AuthService.getProfile()
        .then((res) => {
          const profileData = res?.user?.user || res?.user || res;
          setUser(profileData);
          localStorage.setItem(USER_KEY, JSON.stringify(profileData));
          dispatch({ type: "SET_USER", payload: profileData });
        })
        .catch((error) => {
          console.error("Error al revalidar perfil:", error);
          logout();
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        conversion,
        currentRouter: null,
        isLoading,
        isLogged,
        login: handleLogin,
        logout,
        setConversion,
        user,
      }}
    >
      {isLoading ? <Spinner /> : children}
    </AuthContext.Provider>
  );
};

const Spinner = () => (
  <div className="w-screen h-screen flex justify-center items-center bg-[#F8F6FD]">
    <SpinnerComponent />
  </div>
);
